import type from "./type";

const ImageChange = (payload) => ({
  type: type.onImageChange,
  payload,
});

export { ImageChange };
